type TvWindow = Window & {
  tizen?: unknown;
  webOS?: unknown;
  webOSSystem?: unknown;
  webos?: unknown;
  TitanSDK?: unknown;
};

/**
 * Platform is chosen when the app runs, not when Vite builds.
 * One bundle is published to tizen, webOS and TitanOS; the TV runtime
 * (or the CDN host) decides which AppConfig is used.
 */
export const resolvePlatformCode = (): string => {
  if (typeof window !== "undefined") {
    const tv = window as TvWindow;
    if (tv.tizen) {
      return "TIZEN";
    }
    if (tv.TitanSDK) {
      return "TITAN_OS";
    }
    if (tv.webOS || tv.webOSSystem || tv.webos) {
      return "WEB_OS";
    }

    const host = window.location?.hostname ?? "";
    if (/^tizen(?:\.|$)/i.test(host)) {
      return "TIZEN";
    }
    if (/^titanos(?:\.|$)/i.test(host)) {
      return "TITAN_OS";
    }
    if (/^webos(?:\.|$)/i.test(host)) {
      return "WEB_OS";
    }
  }

  return (
    process.env.NEXT_PUBLIC_PLATFORM_CODE ||
    process.env.REACT_APP_PLATFORM_CODE ||
    ""
  );
};
